var App = App || {};

App.ScrollAnimate = (function ($) {

    'use strict';

    function ScrollAnimate() {

        //hp banner
        const hpBanner = $(".widget-homepage-banner");
        const hpBannerOffset = 75;
        const hpBannerTargets = [
            { selector: ".widget-homepage-banner-image", type: "animate__fadeIn", stagger: 0 },
            { selector: ".widget-homepage-banner-content > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const hpBannerOverflow = false;

        hpBanner.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: hpBannerOffset,
            targets: hpBannerTargets,
            overflow: hpBannerOverflow
        });

        //masthead
        const masthead = $(".widget-masthead");
        const mastheadOffset = 75;
        const mastheadTargets = [
            { selector: ".widget-masthead-image", type: "animate__fadeInUp", stagger: 0 },
            { selector: ".widget-masthead-content > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const mastheadOverflow = false;

        masthead.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: mastheadOffset,
            targets: mastheadTargets,
            overflow: mastheadOverflow
        });

        //features
        const features = $(".widget-features-callout-band");
        const featuresOffset = 75;
        const featuresTargets = [
            { selector: ".widget-features-callout-band__container", type: "animate__fadeInUp", stagger: 400 }

        ]
        const featuresOverflow = false;

        features.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: featuresOffset,
            targets: featuresTargets,
            overflow: featuresOverflow
        });


        //testimonials
        const testimonial = $(".widget.testimonials");
        const testimonialOffset = 75;
        const testimonialTargets = [
            { selector: ".item-testimonial > *", type: "animate__fadeInUp", stagger: 400 }

        ]
        const testimonialOverflow = false;

        testimonial.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: testimonialOffset,
            targets: testimonialTargets,
            overflow: testimonialOverflow
        });


        //structure
        const structure = $(".widget-structure");
        const structureOffset = 75;
        const structureTargets = [
            { selector: ".widget-structure-layout > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const structureOverflow = true;

        structure.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: structureOffset,
            targets: structureTargets,
            overflow: structureOverflow
        });


        //resource widget
        const resourceItem = $(".widget-resource-items-layout");
        const resourceItemOffset = 75;
        const resourceItemTargets = [
            { selector: ".widget-resource-item", type: "animate__fadeInUp", stagger: 400 }
        ]
        const resourceItemOverflow = false;

        resourceItem.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: resourceItemOffset,
            targets: resourceItemTargets,
            overflow: resourceItemOverflow
        });


    }

    return {
        ScrollAnimate: ScrollAnimate
    };

})(jQuery);

$(function () {
    App.ScrollAnimate.ScrollAnimate();
});